import React, { useContext, useState } from 'react'
import lock from '../Components/Images/lock.svg'
import copy from '../Components/Images/Copy2.svg'
import { Context } from '../Context/Context'
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import DownloadButton from '../Components/Images/DownloadButton.svg'
// import check_circle from '../Components/Images/check-circle.svg'
// import google from '../Components/Images/Google.svg';
// import facebook from '../Components/Images/facebook.svg';
// import { useLocation } from 'react-router-dom';

const ExternalInvoice1 = () => {

    const { ref } = useContext(Context)
    const [copied, setCopied] = useState(false);
    const invoiceDetails = JSON.parse(localStorage.getItem('invoiceData'))
    const userSelectedInvoiceAcct = JSON.parse(localStorage.getItem('userSelectedInvoiceAcct'))


    // const [paymentMade, setPaymentMade] = useState(false)
    // const [receiptFetched, setReceiptFetched] = useState(false)
    // const [isSubmitting, setIsSubmitting] = useState(false);
    // const location = useLocation();
    // const hasDownloaded = useRef(false)
    // const ref = useRef();
    // const ref2 = useRef();

    const handleCopy = async () => {
        const textToCopy = userSelectedInvoiceAcct.account_number?.trim() || userSelectedInvoiceAcct.iban?.trim();

        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopied(true);

            setTimeout(() => setCopied(false), 1000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <>
            {/* {paymentMade ? (
                <div className='flex xl:flex-row flex-col items-center xl:items-start justify-center'>
                    <div className='xl:block hidden'>
                        <div className='h-[90vh] flex flex-col w-full max-w-[720px] justify-center items-center'>
                            <div className='w-full flex justify-center items-center px-[120px]'>
                                <div className='xl:w-[400px] text-center flex flex-col justify-center items-center'>
                                    <img src={check_circle} alt="" />
                                    <p className='text-[28px] font-semibold text-[#1D1C1F] mt-4'>Your payment was successful!</p>
                                    <p className='text-[#525154] font-normal text-[14px] mt-2'>We sent a receipt to your email!</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex justify-between w-full px-[80px]'>
                            <p className='text-[#525154] text-[14px] font-medium'>
                                Powered by <span className='text-[#531CB3]'>reccur</span>
                            </p>
                            <p className='text-[#525154] text-[14px] font-medium'>
                                Need help? <span className='text-[#531CB3]'>help@reccur.com</span>
                            </p>
                        </div>
                    </div>
                    <div className='flex xl:hidden justify-between items-center mh:mt-10 p-5 max-w-[865px] w-full rounded-lg bg-[#F9F7FC]'>
                        <div className='flex mh:flex-row flex-col justify-between w-full items-start mh:items-center'>
                            <div className='flex items-start gap-2'>
                                <img src={check_circle} className='size-8 mt-2' alt="" />
                                <div>
                                    <p className='sd:text-[28px] text-[20px] font-semibold text-[#1D1C1F]'>Your payment was successful!</p>
                                    <p className='text-[#525154] font-normal text-[14px]'>We sent a receipt to your email!</p>
                                </div>
                            </div>
                            <img
                                // onClick={() => {
                                //     generatePDF2()
                                //     setReceiptFetched(true)
                                // }}
                                src={DownloadButton}
                                className='ml-10 cursor-pointer mh:ml-0 mh:mt-0 mt-2' alt=""
                            />
                        </div>
                    </div>
                    <div className='w-full md:max-w-[720px] py-20 md:px-[100px] px-10 bg-white xl:bg-[#F9F7FC]'>
                        <p className='text-[#1D1C1F] leading-7 font-semibold text-[25px]'>Send invoices and receive borderless payments</p>
                        <p className='text-[#525154] text-[14px] font-normal mt-1'>Manage your payers, create invoices, send and receive payments without any location restriction.</p>
                        <div className='mt-14 flex flex-col gap-6'>
                            <div className='flex flex-col gap-[6px]'>
                                <label className='text-[#525154] text-[14px] font-medium' htmlFor="email">Email address</label>
                                <input
                                    className='w-full py-[10px] px-[14px] placeholder:text-[#78757A] placeholder:text-[16px] placeholder:font-normal border-[1.2px] border-[#D2D0D6] rounded-lg'
                                    type="text"
                                    name=""
                                    id=""
                                    placeholder='you@example.com'
                                />
                            </div>
                            <div className='flex flex-col gap-[6px]'>
                                <label className='text-[#525154] text-[14px] font-medium' htmlFor="email">Password</label>
                                <input
                                    className='w-full py-[10px] px-[14px] placeholder:text-[#78757A] placeholder:text-[16px] placeholder:font-normal border-[1.2px] border-[#D2D0D6] rounded-lg'
                                    type="text"
                                    name=""
                                    id=""
                                    placeholder='(at least 8 characters)'
                                />
                            </div>
                            <div className='flex flex-col gap-3'>
                                <button
                                    className={`text-white mt-2 flex gap-3 items-center justify-center py-3 px-5 w-full rounded-lg ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        'Loading...'
                                    ) : (
                                        'Create free account'
                                    )}
                                </button>
                            </div>
                            <hr className='border mt-3 border-[#E6E4EB]' />
                            <div className='flex flex-col gap-4'>
                                <button className='px-4 py-3 w-full flex justify-center gap-3 rounded-lg border-[1.4px] bg-white border-[#E6E4EB]'>
                                    <img src={google} alt="" />
                                    <p className='text-[#525154] font-medium text-[16px]'>Sign up with Google</p>
                                </button>
                                <button className='px-4 py-3 w-full flex justify-center gap-3 rounded-lg border-[1.4px] bg-white border-[#E6E4EB]'>
                                    <img src={facebook} alt="" />
                                    <p className='text-[#525154] font-medium text-[16px]'>Sign up with Facebook</p>
                                </button>
                                <p className='text-[16px] text-[#525154] font-normal'>By clicking “Create free account” or “Sign up with Google or Facebook” you agree to reccur’s <span className='text-[#531CB3] cursor-pointer'>Privacy policy <span className='text-[#525154]'>and</span> Terms of service.</span></p>
                            </div>
                        </div>
                    </div>
                    <div className='flex xl:hidden justify-between w-full md:px-[80px] px-4 my-[100px]'>
                        <p className='text-[#525154] text-[14px] font-medium'>
                            Powered by <span className='text-[#531CB3]'>reccur</span>
                        </p>
                        <p className='text-[#525154] text-[14px] font-medium'>
                            Need help? <span className='text-[#531CB3]'>help@reccur.com</span>
                        </p>
                    </div>
                </div>
            ) : ( */}
            <div
                ref={ref}
                className="flex mk:flex-row flex-col justify-center w-full mk:max-w-[1440px] mx-auto bg-white"
                style={{ paddingBottom: 0 }} // prevent extra bottom padding
            >
                <div className="py-10 mk:max-w-[440px] w-full">
                    <div className="mk:px-[45px] px-9">
                        <div className="lg:w-[314px] mk:w-[274px] w-full">
                            <p className="text-[#1D1C1F] font-semibold text-[24px]">Pay invoice</p>
                            <p className="text-[14px] text-[#525154] font-normal">
                                Transfer the money to the account below, then click ‘I’ve made the transfer’ once it’s
                                sent
                            </p>
                            <div className="mt-8">
                                <div className="flex items-center gap-3 py-[14px] w-full justify-center bg-[#F9F7FC] rounded-lg">
                                    <img src={lock} alt="lock" />
                                    <p className="text-[13px] text-center font-normal text-[#525154]">All payments are secure and encrypted.</p>
                                </div>
                                <p className="text-center text-[15px] mt-8 font-medium text-[#1D1C1F]">
                                    You will be charged $
                                    {invoiceDetails?.breakdown
                                        ?.reduce((total, item) => {
                                            const itemAmount = item.unit_price && item.quantity ? item.unit_price * item.quantity : 0;
                                            return total + itemAmount;
                                        }, 0)
                                        .toFixed(2)}
                                </p>
                            </div>
                            <div className="text-[#1D1C1F] font-medium mt-8 flex flex-col gap-5">
                                <div className="flex justify-between">
                                    <p className="text-[15px]">Bank Account Details</p>
                                    <button
                                        onClick={handleCopy}
                                        className="flex items-center gap-2 text-[#542d9d] text-[14px] font-semibold cursor-pointer bg-transparent border-none focus:outline-none"
                                    >
                                        {copied ? 'Copied!' : 'Copy details'}
                                        <img src={copy} alt="copy" />
                                    </button>
                                </div>
                                <div>
                                    <p className="text-[#B5B3BA] text-[12px] font-normal">Bank Information</p>
                                    <p className="text-[14px]">{userSelectedInvoiceAcct?.bank_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <p className="text-[#B5B3BA] text-[12px] font-normal">Beneficiary Name</p>
                                    <p className="text-[14px]">
                                        {userSelectedInvoiceAcct?.first_name || 'N/A'} {userSelectedInvoiceAcct?.last_name || 'N/A'}
                                    </p>
                                </div>
                                {userSelectedInvoiceAcct?.account_number && (
                                    <div className="mt-[10px]">
                                        <p className="text-[#B5B3BA] text-[12px] font-normal">Account Number</p>
                                        <p className="text-[14px]">{userSelectedInvoiceAcct.account_number}</p>
                                    </div>
                                )}
                                {userSelectedInvoiceAcct?.routing_number && (
                                    <div className="mt-[10px]">
                                        <p className="text-[#B5B3BA] text-[12px]">Routing Number</p>
                                        <p className="text-[14px] font-medium">{userSelectedInvoiceAcct.routing_number}</p>
                                    </div>
                                )}
                                {userSelectedInvoiceAcct?.iban && (
                                    <div className="mt-[10px]">
                                        <p className="text-[#B5B3BA] text-[12px]">IBAN Number</p>
                                        <p className="text-[14px] font-medium">{userSelectedInvoiceAcct.iban}</p>
                                    </div>
                                )}
                                {userSelectedInvoiceAcct?.bic_swift && (
                                    <div className="mt-[10px]">
                                        <p className="text-[#B5B3BA] text-[12px]">BIC Swift Number</p>
                                        <p className="text-[14px] font-medium">{userSelectedInvoiceAcct.bic_swift}</p>
                                    </div>
                                )}
                            </div>
                            <button
                                data-html2canvas-ignore
                                // onClick={() => {
                                //     setPaymentMade(true);
                                //     window.scrollTo(0, 0);
                                // }}
                                className="text-white text-[14px] mt-8 font-medium rounded-lg py-3 px-5 w-full bg-[#531CB3]"
                            >
                                I’ve made the transfer
                            </button>
                        </div>
                    </div>
                    <div className="flex sh:flex-row flex-col justify-between mt-20 mk:px-4 px-2">
                        <p className="text-[#525154] text-[13px] font-medium">
                            Sent with <span className="text-[#531CB3]">reccur</span>
                        </p>
                        <p className="text-[#525154] text-[13px] font-medium">
                            Need help? <span className="text-[#531CB3]">help@reccur.com</span>
                        </p>
                    </div>
                </div>

                <div className="w-full mk:max-w-[1000px] py-10 mk:px-[54px] px-9 bg-[#F9F7FC]">
                    <p className="text-[#531CB3] font-semibold text-[28px]">{invoiceDetails?.payer_name}</p>
                    <p className="text-[#1D1C1F] text-[18px] font-medium">Bill from</p>
                    <div>
                        <p className="text-[16px] font-normal text-[#302F33]">{invoiceDetails?.user?.fullname}</p>
                        <p className="text-[14px] font-normal text-[#531CB3]">{invoiceDetails?.user?.email}</p>
                    </div>
                    <div className="mt-7">
                        <p className="text-[18px] text-[#1D1C1F] font-medium">Invoice summary</p>

                        {invoiceDetails?.breakdown?.map((item, index) => (
                            <div key={index}>
                                <div className="flex justify-between gap-8 my-5">
                                    <p className="text-[#302F33] text-[16px]">{item.item_name}</p>
                                    <p className="text-[#302F33] text-[16px]">${(item.unit_price * item.quantity).toFixed(2)}</p>
                                </div>

                                {item.unit_price && item.quantity && (
                                    <div className="mt-2 flex flex-col gap-2">
                                        <p className="text-[14px] text-[#78757A]">Unit price: ${item.unit_price}</p>
                                        <p className="text-[14px] text-[#78757A]">Quantity: {item.quantity}</p>
                                    </div>
                                )}
                            </div>
                        ))}

                        <div className="text-[16px] text-[#1D1C1F] flex justify-between border-[1.8px] border-[#F3F0F7] rounded-lg p-4 mt-5">
                            <p>Total</p>
                            <p className="font-semibold">
                                $
                                {invoiceDetails?.breakdown
                                    ?.reduce((total, item) => {
                                        const itemAmount = item.unit_price && item.quantity ? item.unit_price * item.quantity : 0;
                                        return total + itemAmount;
                                    }, 0)
                                    .toFixed(2)}
                            </p>
                        </div>

                        <div className="mt-7 flex flex-col gap-3">
                            <p className="text-[18px] font-medium text-[#1D1C1F]">Invoice note</p>
                            <p className="text-[#525154] text-[16px]">{invoiceDetails?.notes}</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}

            {/* {receiptFetched && (
                <div className="w-full xl:hidden block py-20 xl:px-[120px] sh:px-[60px] px-9 bg-[#F9F7FC] overflow-hidden">
                    <p className='text-[#531CB3] font-semibold text-[28px]'>{invoiceDetails?.payer_name}</p>
                    <p className='text-[#1D1C1F] text-[18px] font-medium'>Bill from</p>
                    <div>
                        <p className='text-[16px] font-normal text-[#302F33]'>{invoiceDetails?.user?.fullname}</p>
                        <p className='text-[14px] font-normal text-[#531CB3]'>{invoiceDetails?.user?.email}</p>
                    </div>
                    <div className='mt-7'>
                        <p className='text-[18px] text-[#1D1C1F] font-medium'>Invoice summary</p>

                        {invoiceDetails?.breakdown?.map((item, index) => (
                            <div key={index}>
                                <div className='flex justify-between my-5'>
                                    <p className='text-[#302F33] text-[16px]'>{item.item_name}</p>
                                    <p className='text-[#302F33] text-[16px]'>
                                        ${(item.unit_price * item.quantity).toFixed(2)}
                                    </p>
                                </div>

                                {item.unit_price && item.quantity && (
                                    <div className='mt-2 flex flex-col gap-2'>
                                        <p className='text-[14px] text-[#78757A]'>Unit price: ${item.unit_price}</p>
                                        <p className='text-[14px] text-[#78757A]'>Quantity: {item.quantity}</p>
                                    </div>
                                )}
                            </div>
                        ))}

                        <div className='text-[16px] text-[#1D1C1F] flex justify-between border-[1.8px] border-[#F3F0F7] rounded-lg p-4 mt-5'>
                            <p>Total</p>
                            <p className='font-semibold'>
                                ${invoiceDetails?.breakdown?.reduce((total, item) => {
                                    const itemAmount = item.unit_price && item.quantity
                                        ? item.unit_price * item.quantity
                                        : 0
                                    return total + itemAmount;
                                }, 0).toFixed(2)}
                            </p>
                        </div>

                        <div className='mt-7 flex flex-col gap-3'>
                            <p className='text-[18px] font-medium text-[#1D1C1F]'>Invoice note</p>
                            <p className='text-[#525154] text-[16px]'>{invoiceDetails.notes}</p>
                        </div>
                    </div>
                </div>
            )} */}
        </>
    )
}

export default ExternalInvoice1